import React, { createContext, useContext, useState } from "react";
import { MessageToast } from "components"; // your toast component

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toastProps, setToastProps] = useState({
    show: false,
    type: "primary",
    message: "",
    autohide: true,
    delay: 0,
  });

  const openToast = (props) => {
    setToastProps({
      show: true,
      type: "primary",
      autohide: true,
      delay: 2000,
      ...props,
    });
  };

  const closeToast = () => {
    setToastProps((prev) => ({ ...prev, show: false }));
  };

  return (
    <ToastContext.Provider value={{ openToast, closeToast }}>
      <MessageToast {...toastProps} onDismiss={closeToast} />
      {children}
    </ToastContext.Provider>
  );
};
